import React from "react";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import PhotoCamera from "@material-ui/icons/PhotoCamera";
import Style from "../../styles/js/StyleNotifications.js";
import * as ScreenText from "../../consts/ScreenText.js";

export default function UploadButtons({ handleChange }) {
  const style = Style();

  return (
    <div className={style.root}>
      <input
        accept="image/*"
        className={style.inputImage}
        id="contained-button-file"
        name="image"
        multiple
        type="file"
        onChange={handleChange}
        value=""
      />
      <label htmlFor="contained-button-file">
        <Button variant="contained" component="span">
          {ScreenText.NOTIFICATIONS_BUTTON_ADD_IMAGE}
        </Button>
      </label>
      <input
        accept="image/*"
        name="image"
        className={style.inputImage}
        id="icon-button-file"
        type="file"
        onChange={handleChange}
        value=""
      />
    </div>
  );
}
